var map = {
	"./Sabelo_logo.png": 2354,
	"./about-icon_1.png": 8599,
	"./about-icon_2.png": 327,
	"./about-icon_3.png": 7484,
	"./about-icon_4.png": 1533,
	"./about-us-image_1.jpg": 1083,
	"./africapc_logo.png": 4074,
	"./facebook-icon.png": 6964,
	"./home-banner-image_1.jpg": 3316,
	"./instagram-icon.png": 302,
	"./logo_placeholder.png": 3001,
	"./nslogo.png": 4112,
	"./service-image_1.jpg": 8268,
	"./service-image_2.jpg": 7321,
	"./service-image_3.jpg": 9847,
	"./unipower_logo.png": 2645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;